var map = {
	"./012722_national_grid_1-scaled.jpg": 3111,
	"./081823_David-Flatt-02.jpg": 5180,
	"./081823_Laura_hoffman---03.jpg": 4786,
	"./081823_Newtown-Creek06.jpg": 2463,
	"./102323_greenpoint_plume_vaughn_1.jpg": 7045,
	"./102323_newtown_creek_1.jpg": 311,
	"./111523_newtown_creek_walk_1.jpg": 2717,
	"./131023_NewtownCreek_Krales_16_edit.jpg": 1519,
	"./131023_NewtownCreek_Krales_18_edit.jpg": 3972,
	"./131023_NewtownCreek_Krales_1_edit.jpg": 6861,
	"./131023_NewtownCreek_Krales_20_edit.jpg": 8483,
	"./131023_NewtownCreek_Krales_22_edit.jpg": 1189,
	"./Newtown-Creek10_edit.jpg": 971,
	"./newtown_creek_archival_1.jpg": 9871,
	"./sample-photo-1.jpg": 2232,
	"./sample-photo-2.jpg": 662
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7289;